import { ThemeConfig } from 'antd';

export const appTheme: ThemeConfig = {
  token: {},
  components: {
    Layout: {
      headerBg: '#fff',
      siderBg: '#fff',
      bodyBg: '#fff',
      footerBg: '#fff',
      headerColor: '#fff',
      headerHeight: 'none',
      headerPadding: 'none',
    },
  },
};
